import React, { useEffect, useState } from "react";
import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import swal from "sweetalert";

import { GENERAL_URL_API } from "../../../../shared/urls";

const API_PAQUETES = `${GENERAL_URL_API}/recomendacion/paquetesDelAlcance.php`;

/**
 * Selector de paquetes base asignados a los clientes del alcance.
 * Por defecto selecciona todos los paquetes disponibles.
 */
const PaqueteSelector = ({ alcance, paquetes, onChange, disabled }) => {
  const [opciones, setOpciones] = useState([]);
  const [cargando, setCargando] = useState(false);

  const alcanceKey = [
    alcance?.superInstituto ?? "",
    ...(alcance?.institutos ?? []),
    ...(alcance?.clientes ?? []),
  ].join("|");

  useEffect(() => {
    if (!alcance?.superInstituto) {
      setOpciones([]);
      onChange([]);
      return;
    }

    let cancelado = false;

    const cargar = async () => {
      setCargando(true);
      try {
        const fd = new FormData();
        fd.append(
          "alcance",
          JSON.stringify({
            superInstituto: alcance.superInstituto,
            institutos: alcance.institutos ?? [],
            clientes: alcance.clientes ?? [],
          })
        );

        const res = await fetch(API_PAQUETES, {
          method: "POST",
          credentials: "include",
          body: fd,
        });
        const data = await res.json();

        if (cancelado) return;

        if (data.status !== 1) {
          setOpciones([]);
          onChange([]);
          await swal({
            title: "Error",
            text: data.info || "No se pudieron cargar los paquetes",
            icon: "error",
          });
          return;
        }

        const lista = data.data ?? [];
        setOpciones(lista);
        onChange(lista);
      } catch (e) {
        if (!cancelado) {
          setOpciones([]);
          onChange([]);
          await swal({
            title: "Error",
            text: e.message || "No se pudieron cargar los paquetes",
            icon: "error",
          });
        }
      } finally {
        if (!cancelado) setCargando(false);
      }
    };

    cargar();

    return () => {
      cancelado = true;
    };
    // onChange estable desde el padre (setPaquetes)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alcanceKey]);

  return (
    <div>
      <label className="admin-label-text mt-3 d-block">
        Paquetes base (libros en amarillo):
      </label>
      <Autocomplete
        multiple
        disableCloseOnSelect
        options={opciones}
        getOptionLabel={(option) => option}
        value={paquetes}
        onChange={(_, valor) => onChange(valor)}
        disabled={disabled || cargando || !alcance?.superInstituto}
        loading={cargando}
        noOptionsText={
          alcance?.superInstituto
            ? "Sin paquetes asignados en el alcance"
            : "Selecciona un Super Instituto"
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            size="small"
            placeholder={
              cargando
                ? "Cargando paquetes..."
                : "Todos los paquetes del alcance"
            }
            style={{ width: "100%", fontFamily: "'Noto Sans JP', sans-serif" }}
          />
        )}
      />
      <div className="admin-muted-text-small mt-2">
        Solo paquetes asignados hoy a los clientes del alcance. Los libros del
        paquete sin territorio válido no aparecen en el catálogo.
      </div>
    </div>
  );
};

export default PaqueteSelector;
